import { useContext } from "react";
import { NotificationsContext, NotificationsContextType } from "../contexts/notification.context";

export const useNotification = () => {
    return useContext(NotificationsContext) as NotificationsContextType;
};
